import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as shiftReportListAction from "../../../store/report-shift/action";

import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  // GET_SHIFT_DAILY_REPORT,
  SEND_MAIL_SHIFT_REPORT,
  GET_RP_SHIFT,
  baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import BootstrapTable from "react-bootstrap-table-next";
import { DatePicker } from "antd";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import Select from "react-select";
import classnames from "classnames";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
//i18n

function ShiftReport(props) {
  let history = useHistory();
  const location = useLocation();
  const shiftReportListReducer = useSelector(state => state.ShiftReportList)
  const dispatch = useDispatch();
  const permission = getPermission();
  const toGasDate = moment().add(-1, 'day');

  // console.log(toGasDate);
  // console.log(shiftReportListReducer);
  const searchObj = location?.state?.goBack == true ? shiftReportListReducer.modelSearch : { SHIFT_DAILY: moment(new Date(toGasDate.year(), 0, 1)), TO_SHIFT_DAILY: moment(new Date(toGasDate.year(), 11, 31)), };
  // const searchObj = { SHIFT_DAILY: moment(new Date(toGasDate.year(), 0, 1)), TO_SHIFT_DAILY: moment(new Date(toGasDate.year(), 11, 31)), };

  const [searchModel, setSearchModel] = useState(searchObj);
  // const [modelDeviceList, setModelDeviceList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState(location?.state?.goBack == true ? shiftReportListReducer.modelDeviceList : []);
  const [activeTab, setActiveTab] = useState("1");


  useEffect(() => {
    dispatch(shiftReportListAction.setModelDeviceListToState(modelDeviceList))
  }, [modelDeviceList])


  //sort Column//
  const defaultSorted = [
    {
      dataField: "SHIFT_DAILY",
      order: "desc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    page: location?.state?.goBack == true ? shiftReportListReducer.pagination.page : 1,
    sizePerPage: location?.state?.goBack == true ? shiftReportListReducer.pagination.sizePerPage : 100,
    onSizePerPageChange: (sizePerPage, page) => {
      dispatch(shiftReportListAction.setPaginationToState({ sizePerPage, page }))
    },
    onPageChange: (page, sizePerPage) => {
      dispatch(shiftReportListAction.setPaginationToState({ sizePerPage, page }))
    },
    paginationSize: 4,
    pageStartIndex: 1,

    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [

      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//



  // Action Button//
  const ButtonAction = (cellContent, row) => {
    // console.log(row);
    return (
      <div>
        {permission.vSTR && (
          <>
            <OverButton
              onClick={() => {
                gotoPageShiftDetail(row);
              }}
              color="primary"
              icon="fas fa-eye"
              label="View Detail"
            />
            <OverButton
              onClick={() => {
                downloadExcel(row);
              }}
              color="success"
              icon="fas fa-file-download fa-lg"
              label="Download Excel"
            />
          </>
        )}
        {permission.eSTR == true && row.SHIFT_APPROVE != null && (
          <OverButton
          onClick={() => {
            dispatch(
              confirmAction.showConfirm(
                "Do you want to send e-mail ?",
                () => {
                  sendmailShift(row);
                }
              )
            );
          }}
            // onClick={() => {
            //   sendmailShift(row);
            // }}
            color="info"
            icon="mdi mdi-email-send fa-lg"
            label="Send E-mail"
          />
        )}
      </div>
    );
  };

  const gotoPageShiftDetail = row => {
    // console.log(row);
    history.push("/shift-report/" + row.PID + "/" + moment(row.SHIFT_DAILY).format("YYYY-MM-DD") + "/shift-report-detail");
  };

  // Action Button//

  const downloadExcel = async (row) => {
    // console.log(row);
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/Report/downloadExcelShiftReport?SHIFT_DAILY=" + moment(row.SHIFT_DAILY).format("YYYY-MM-DD"), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',  ///
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      // fetch("https://tsoopwb.pttplc.com/api/DownloadFile/DownloadBookingFile?szFileName=" + pid , {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/vnd.ms-excel',
      //     'Authorization':"Bearer " + accessToken.access_token
      //   },
      // })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        // console.log(blob);
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          'Shift_Report_' + moment(row.SHIFT_DAILY).format("DD-MM-YYYY") + '.xlsx'
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };

  const sendmailShift = async (row) => {
    let date = row.SHIFT_DAILY

    dispatch(loadingAction.showLoading());
    try {
      // console.log(row.SHIFT_DAILY);
      let res = await post(SEND_MAIL_SHIFT_REPORT, { SHIFT_DATE: moment(date).format("YYYY-MM-DD") });
      if (res.resultCode != 200) {
        dispatch(messageAction.showMessage(res.resultDescription));
      } else {
        dispatch(messageAction.showMessage("Sending email."));
        fetchData(searchModel);
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  const CheckSentMail = (cellContent, row) => {
    let label = "";
    // row.STATUS_EMAIL = 5;
    if (row.STATUS_EMAIL == 0) {
      label = "Wait to send e-mail";
    } else if (row.STATUS_EMAIL == 1) {
      label = "Sending";
    } else if (row.STATUS_EMAIL == 2) {
      label = "Failed to send e-mail";
    } else {
      label = "Send e-mail success";
    }

    return (
      <div>
        <label>
          {label}
        </label>
      </div>
    );
  };

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },

    {
      dataField: "SHIFT_DAILY",
      text: "Gas Day",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.SHIFT_DAILY, "DD/MM/YYYY"),
    },

    {
      dataField: "STATUS_EMAIL",
      text: "Status",
      headerAlign: "center",
      formatter: CheckSentMail,
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: false,
    },

    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Status",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {},
    //   sort: true,
    //   isDummyField: true,
    //   formatter: (cellContent, row) => CheckActive(row.STATUS_FLAG),
    // },

    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: ButtonAction,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    if (location?.state?.goBack != true) {
      resetSearch();
    }
    resetModel();
    // setModelDeviceList(listData);
    let tableId = "shift-report-table";
    let scrollY = 213;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  const resetSearch = () => {
    setSearchModel({ SHIFT_DAILY: moment(new Date(toGasDate.year(), 0, 1)), TO_SHIFT_DAILY: moment(new Date(toGasDate.year(), 11, 31)), });
    fetchData({ SHIFT_DAILY: moment(new Date(toGasDate.year(), 0, 1)), TO_SHIFT_DAILY: moment(new Date(toGasDate.year(), 11, 31)), });
  };

  const resetModel = () => {
    // setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const fetchData = async (searchData) => {
    dispatch(shiftReportListAction.setSearchToState(searchData))
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_RP_SHIFT, { ...searchData, SHIFT_DAILY: moment(searchData.SHIFT_DAILY).format("YYYY-MM-DD"), TO_SHIFT_DAILY: moment(searchData.TO_SHIFT_DAILY).format("YYYY-MM-DD") });
      // console.log(res);
      setModelDeviceList(res.data.rpShiftList.map(obj => ({
        ...obj,
        SHIFT_DAILY: moment(obj.SHIFT_DAILY).toDate()
      }
      ))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Shift")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Report
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Shift</li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>

                      <Row>
                        <Col sm="4">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Start Gas Day
                            </Label>
                            <Col sm={8}>
                              <DatePicker
                                style={{ width: 235, height: 38, marginLeft: 0 }}
                                // defaultValue={moment(dateSelected)}
                                format={"MMM YYYY"}
                                placeholder="Select Month"
                                onChange={(date, dateString) => {
                                  // console.log(date)
                                  if (date != null) {
                                    setSearchModel({
                                      ...searchModel,
                                      SHIFT_DAILY: date,
                                    });
                                  }
                                }}
                                picker="month"
                                value={searchModel.SHIFT_DAILY}
                              // disabledDate={disabledDate}
                              />
                              {/* 
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "d/m/Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      SHIFT_DAILY: value[0]

                                    })
                                }}
                                value={searchModel.SHIFT_DAILY}
                              /> */}
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              End Gas Day
                            </Label>
                            <Col sm={8}>
                              <DatePicker
                                style={{ width: 235, height: 38, marginLeft: 0 }}
                                // defaultValue={moment(dateSelected)}
                                format={"MMM YYYY"}
                                placeholder="Select Month"
                                onChange={(date, dateString) => {
                                  // console.log(date)
                                  if (date != null) {
                                    setSearchModel({
                                      ...searchModel,
                                      TO_SHIFT_DAILY: date,
                                    });
                                  }
                                }}
                                picker="month"
                                value={searchModel.TO_SHIFT_DAILY}
                              // disabledDate={disabledDate}
                              />

                              {/* <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "d/m/Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      TO_SHIFT_DAILY: value[0]

                                    })
                                }}
                                value={searchModel.TO_SHIFT_DAILY}
                              /> */}
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="row">
                            <div className="d-flex align-items-center justify-content-center">
                              <Button color="info" className="mt-0"
                                onClick={() => onSearch()}
                              >
                                <i className="fas fa-search"></i>
                                &nbsp; Search
                              </Button>

                              <Button color="warning" className="mt-0 ms-2"
                                onClick={() => resetSearch()}
                              >
                                <i className="fas fa-redo-alt"></i>
                                &nbsp; Reset
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* <Row className="mt-5">
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              EOD Summary
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row> */}

                      <Row className="mt-4">
                        <hr />
                      </Row>

                      <Row className="mt-0">
                        {/* <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1"> */}

                        <Col sm="12">
                          <div>
                            <BootstrapTable
                              id="shift-report-table"
                              keyField="PID"
                              data={modelDeviceList}
                              columns={columns}
                              headerClasses="header-style"
                              rowStyle={rowStyleFontWhite}
                              defaultSorted={defaultSorted}
                              pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>

                        {/* </TabPane>
                        </TabContent> */}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

          </Row>
        </Container>

      </div>
    </React.Fragment>
  );
}

ShiftReport.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ ShiftReport }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ShiftReport));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
